import React, { useState } from 'react';
import { useTable, usePagination } from 'react-table';
import Modal from '../../../../components/Modal/Modal';
import EmptyData from '../../../../components/EmptyData/EmptyData';
import Loader from '../../../../components/Loader/Loader';
import icon from '../../../../brand/generated/buttonIcons/addDeal.svg';
import getDealHistory from '../../../../api/deals/getDealHistory';
import { DEAL_HISTORY } from '../../../../constants/columns';

const columns = DEAL_HISTORY;

const DealHistoryModal = ({ dealId, isOpen, onClose }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const table = useTable(
    {
      columns,
      data: history,
      initialState: { pageIndex: 0, pageSize: 1000000 },
    },
    usePagination
  );

  const init = async () => {
    setLoading(true);
    await getDealHistory({ id: dealId })
      .then((res) => {
        setHistory(res?.data || []);
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    if (isOpen && dealId) init();
  }, [isOpen, dealId]);

  return (
    <Modal
      isOpen={isOpen}
      title="ÐÑÑÐ¾ÑÐ¸Ñ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹ ÑÐ´ÐµÐ»ÐºÐ¸"
      onRequestClose={onClose}
      contentStyle={{
        top: '10%',
        height: 'fit-content',
        width: 900,
      }}
    >
      {loading ? (
        <Loader />
      ) : (
        <EmptyData
          title={`ÐÑÑÐ¾ÑÐ¸Ñ (${history.length})`}
          subtitle={'ÐÐ¾ ÑÑÐ¾Ð¹ ÑÐ´ÐµÐ»ÐºÐµ Ð¿Ð¾ÐºÐ° Ð½ÐµÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹ Ð² ÑÐ¾ÑÑÐ°Ð²Ðµ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ñ, ÑÑÐ»ÑÐ³ Ð¸Ð»Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¹.'}
          action={null}
          icon={icon}
          table={table}
          data={history}
        />
      )}
    </Modal>
  );
};

export default DealHistoryModal;
